const STAGE_PRESENTATIONS = Object.freeze({
  preparing_snapshot: Object.freeze({
    label: 'Preparing snapshot',
    bootstrapDetail: 'Preparing the authoritative order snapshot for this desktop.',
    rebuildDetail: 'Preparing a replacement authoritative order snapshot.',
  }),
  downloading_order_data: Object.freeze({
    label: 'Downloading order data',
    bootstrapDetail: 'Downloading the initial offline order history.',
    rebuildDetail: 'Downloading replacement offline order history.',
  }),
  catching_up_order_changes: Object.freeze({
    label: 'Catching up order changes',
    bootstrapDetail: 'Applying cloud changes that happened while the baseline downloaded.',
    rebuildDetail: 'Applying cloud changes that happened while the replacement downloaded.',
  }),
  checking_snapshot: Object.freeze({
    label: 'Checking snapshot',
    bootstrapDetail: 'Checking the downloaded snapshot before installation.',
    rebuildDetail: 'Checking the replacement snapshot before installation.',
  }),
  protecting_and_saving: Object.freeze({
    label: 'Protecting and saving offline data',
    bootstrapDetail: 'Protecting and atomically saving the offline order baseline.',
    rebuildDetail: 'Protecting and atomically saving the replacement order baseline.',
  }),
  cleaning_temporary_parts: Object.freeze({
    label: 'Cleaning temporary data',
    bootstrapDetail: 'Removing protected temporary download parts.',
    rebuildDetail: 'Removing protected temporary replacement parts.',
  }),
  ready_for_offline_work: Object.freeze({
    label: 'Ready for offline work',
    bootstrapDetail: 'The protected offline order baseline was accepted.',
    rebuildDetail: 'The replacement protected order baseline was accepted.',
  }),
});

function safeInteger(value, minimum = 0) {
  return Number.isSafeInteger(value) && value >= minimum ? value : null;
}

export function orderDataProgressPresentation(progress) {
  if (!progress || !['bootstrap', 'rebuild'].includes(progress.operation)) return null;
  const stage = STAGE_PRESENTATIONS[progress.stage];
  if (!stage) return null;
  const step = safeInteger(progress.step, 1);
  const totalSteps = safeInteger(progress.totalSteps, 1);
  if (step === null || totalSteps === null || step > totalSteps) return null;

  const bytesReceived = safeInteger(progress.bytesReceived);
  const bytesTotal = safeInteger(progress.bytesTotal, 1);
  const trustedBytes = bytesReceived !== null
    && bytesTotal !== null
    && bytesReceived <= bytesTotal;
  const percent = trustedBytes
    ? Math.min(100, Math.floor((bytesReceived / bytesTotal) * 100))
    : null;
  const orderCount = safeInteger(progress.orderCount);
  const preservingBaseline = progress.operation === 'rebuild'
    && progress.previousBaselineAvailable === true;

  return Object.freeze({
    operation: progress.operation,
    stage: progress.stage,
    label: stage.label,
    detail: progress.operation === 'rebuild' ? stage.rebuildDetail : stage.bootstrapDetail,
    step,
    totalSteps,
    bytesReceived,
    bytesTotal: trustedBytes ? bytesTotal : null,
    percent,
    orderCount,
    preservingBaseline,
  });
}

export function formatProgressBytes(value) {
  if (!Number.isSafeInteger(value) || value < 0) return null;
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KiB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MiB`;
}
